import IconsEnum from "../../classes/enums/IconsEnum";
import { MODALITY } from "../../classes/enums/MedicalImagesEnum";
import { iconMapping } from "../../config/iconConfig";
import { useDateFormatter } from "../../hooks/useDateFormatter";
import "./Thumbnail.css";

const Thumbnail = ({
  imageSrc,
  name,
  date,
  modality = MODALITY.DX,
  isSelected = false,
  showMarker = false,
  numberOfImages = 1,
  orientation = null,
  useModality = false,
}) => {
  const formatDate = useDateFormatter();
  const SelectedIcon = iconMapping[IconsEnum.CONFIRM];
  const FallbackIcon = iconMapping[IconsEnum.MEDICALIMAGE];

  const nameText = useModality ? modality : name;
  const numberOfImagesText =
    !orientation && numberOfImages > 1 ? `(${numberOfImages})` : "";
  const orientationText = orientation
    ? `(${orientation[0].toUpperCase()})`
    : "";

  // Check if imageSrc is available
  const hasValidImageSrc = imageSrc && imageSrc.trim() !== "";

  return (
    <div
      className={`instance-thumbnail-wrapper ${isSelected ? "selected" : ""}`}
    >
      {hasValidImageSrc ? (
        <img src={imageSrc} className="instance-thumbnail-image" alt={name} />
      ) : (
        <div className="instance-thumbnail-placeholder">
          <FallbackIcon className="instance-thumbnail-placeholder-icon" />
        </div>
      )}
      <div className="instance-thumbnail-overlay">
        {isSelected && showMarker && (
          <div className="thumbnail-selected-marker">
            {" "}
            <SelectedIcon />
          </div>
        )}
        <div className="text-region-overlay">
          <span className="instance-title-thumbnail  instance-label-text App-text-small">
            {nameText} {numberOfImagesText} {orientationText}
          </span>
          <span className="instance-date-thumbnail App-text-small">
            {formatDate(date)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Thumbnail;
